import {Component, OnDestroy, OnInit} from '@angular/core';
import {RefreshEvent} from '@events/RefreshEvent';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {ThingModalEvent} from '@events/ThingModalEvent';
import {ThingToggleEvent} from '@events/things/ThingToggleEvent';
import {ParkService} from "@core/park/park.service";
import {ThingService} from "@core/thing/thing.service";
import {KngActivityIndicatorService} from '@layout/kingswell/services/kngActivityIndicator.service';
import {THINGS_LIST_TABS} from '../../../constants/things.constants';
import {KngDrawerService} from "@layout/kingswell/services/kngDrawer.service";
import {ThingsToggleComponent} from "@components/things/toggle/toggle.component";
import {MainKngContentScrollEvent} from "@events/MainKngContentScrollEvent";
import {OpenLandModalEvent} from "@events/OpenLandModalEvent";
import {Area} from "@core/area";
import {state, trigger, transition, style, animate} from "@angular/animations";
import {Subscription} from "rxjs/Subscription";
import {ThingsResult} from "@providers/thing.provider";

@Component({
  selector: 'things-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.less'],
  animations: [
    trigger('tabUnderline', [
      state('cans', style({
        left: '-200%',
      })),
      state('restrooms',   style({
        left: '-100%',
      })),
      state('time-based',   style({
        left: '0',
      })),
      transition('* <=> *', animate('500ms ease-in-out'))
    ])
  ]
})
export class ThingsListComponent implements OnInit, OnDestroy {

  things = [];
  tab;
  tabs = THINGS_LIST_TABS;

  searchText = '';
  filteredThings = [];

  types = '';
  areaIds = '';
  status = '';
  typesOptions = [];
  statusOptions = [];
  //added
  // continuationTokenOptions = [];
  //changes 
  // continuationToken = '';

  worldLabel: string = '';
  kingdomLabel: string = '';
  areaLabel: string = '';

  defaultArea: Area;
  defaultAreaLabel: string = '';
  defaultAreaId: string;

  areas: Array<any> = [];

  isLoading: boolean = false;
  showStickyHeader: boolean = false;
  //change
  isTabChange: boolean = true;
  //changes
  // nextPage: boolean = false;
  //changes
  thingsResult: ThingsResult

  private thingToggleSubscription: Subscription;
  private refresherSubscription: Subscription;
  private mainKngContentScrollSubscription: Subscription;

  constructor(private thing: ThingService, private route: ActivatedRoute, private park: ParkService,
              private thingModal: ThingModalEvent, private thingToggle: ThingToggleEvent, private kngDrawerService: KngDrawerService,
              private refresher: RefreshEvent, private kngActivityIndicator: KngActivityIndicatorService, private router: Router,
              private openLandModalEvent: OpenLandModalEvent,
              private mainKngContentScrollEvent: MainKngContentScrollEvent) {
    this.tab = this.tabs[0];
    this.defaultAreaId = route.snapshot.params['areaId'];

    this.areaIds = this.defaultAreaId + "";

    this.park.getNamesByArea({
      areaId: this.defaultAreaId
    }).then(names => {
      if (names.world) {
        this.worldLabel = names.world;
      }
      if (names.kingdom) {
        this.kingdomLabel = names.kingdom;
      }
      if (names.area) {
        this.defaultAreaLabel = names.area;
        this.areaLabel = names.area;
      }
    });

    this.park.getAreaById(this.defaultAreaId)
      .then(area =>{
        let a = area as any;
        return this.park.getKingdomById(a.kingdomId);
      })
      .then(kingdom =>{
        this.areas = kingdom.lands;
      });
  }

  ngOnInit() {
    // The activity indicator is initially opened, force to close
    this.kngActivityIndicator.close();

    // this triggers the inline loader
    this.isLoading = true;

    this.typesOptions = this.getTypes();
    this.statusOptions = this.getStatuses();

    this.thingToggle.on().subscribe(data => {
      if (data.key === 'thingsToggle.save') {
        this.areas == data.areas;
        let selectedAreas = this.areas.filter(area => area.selected);
        this.areaIds = selectedAreas.map(a => a.areaId).join();
        if (selectedAreas.length === 1) {
          this.areaLabel = selectedAreas[0].name;
          this.defaultAreaId = selectedAreas[0].areaId;
          this.defaultArea = selectedAreas[0];
        }

        this.updateUrl({areaIds: this.areaIds});
      }
    });

    this.refresher.on().subscribe(data => {
      if (data === 'thingsList.refresh') {
        this.refreshThings();
      }
    });

    this.route.queryParams.subscribe(params =>{
      this.onParameterChange(params);
    });

    this.mainKngContentScrollEvent.on()
      .subscribe((topScroll) => {
        this.showStickyHeader = (topScroll > 186);
      });
  }

  ngOnDestroy(){
    if (this.thingToggleSubscription)
      this.thingToggleSubscription.unsubscribe();
    if (this.refresherSubscription)
      this.refresherSubscription.unsubscribe();
    if (this.mainKngContentScrollSubscription)
      this.mainKngContentScrollSubscription.unsubscribe();
  }

  onParameterChange(params) {
    if (params.areaIds)
      this.areaIds = params.areaIds;

    if (params.tab) {
      this.tab = this.tabs.find(tab => tab.name === params.tab);
    }

    // assign types regardless
    this.types = params.types ? params.types : '';

    // assign the status regardless
    this.status = params.status ? params.status : '';

    this.refreshThings();
  }

  sortAlphaNum(a,b) {

    const collator = new Intl.Collator(undefined, {numeric: true});
    return collator.compare(a,b);

  }

  refreshThings() {
    // Start the inline loader
    this.isLoading = true;

    // flag the thing list to reload laziy
    this.thing.reloadThingDataLazy();

    this.typesOptions = this.getTypes();
    this.statusOptions = this.getStatuses();
    // if(!this.isTabChange && this.getContinuationToken()){
    // this.continuationToken = this.getContinuationToken();
    // }else{
    //   this.continuationToken = '';
    // }
    
    if (! this.types && this.typesOptions.length) {
      this.types = this.typesOptions[0].value;
    }

    // console.log( this.continuationToken);
    this.thing.getThings({
      areas: this.areaIds,
      types: this.types,
      status: this.status,
      // continuationToken: this.continuationToken
    }).then(things => {
      if(this.searchText){
        // filter if search text exists
        things.results = things.results.filter(thing => {
           return thing.name.toLowerCase().indexOf(this.searchText.toLowerCase()) != -1;
          });
      }
      //  if((things["continuationToken"]==null) && (things["nextContinuationToken"]!="undefined"||things["nextContinuationToken"]!=null))
      //  { 
      //    this.nextPage = true;
      //    this.thingsResult=things;
      //    this.isTabChange = false;
      //  }else{
      //   this.nextPage = false;
      //  }
      // Sort by name
      this.things = things.results
        .sort((a, b) => {
          let aName = a.name ? a.name.toLowerCase() : a.thingId;
          let bName = b.name ? b.name.toLowerCase() : b.thingId;

          return this.sortAlphaNum(aName, bName);
        });
        this.filteredThings = this.things;
      
      // close the inline loader
      this.isLoading = false;
    });
  }

  openFilter($event) {
    $event.preventDefault();
    $event.stopPropagation();

    // this.thingToggle.fire('thingsToggle.open', this.areas,
    //   [this.areaIds]
    // );

    let drawer = this.kngDrawerService.launch(ThingsToggleComponent,{
      windowClass: "kng-filter-drawer"
    });

    drawer.componentInstance.areas = this.areas;
    drawer.componentInstance.selectedAreas = this.areaIds;

    drawer.result
      .then(res => {
        // show success modal
      })
      .catch(err => {

      });
  }

  changeTab($event, tab) {
    $event.preventDefault();
    $event.stopPropagation();
    this.isTabChange = true;
    this.updateUrl({tab: tab, types: '', status: ''});
  }

  openThingsDetails(thing) {
    this.router.navigateByUrl('/things/' + thing.thingId);
    //this.thingModal.fire('thingDetails.open', thing);
  }

  getWorldLabel() {
    return this.worldLabel;
  }

  getKingdomLabel() {
    return this.kingdomLabel;
  }

  getAreaLabel() {
    if (this.areaIds.indexOf(',') > -1) {
      // This is hack for now
      let numToWords = ['two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten']
      let numAreas = this.areaIds.split(',').length;
      return numToWords[numAreas - 2] + ' areas';
    }

    return this.areaLabel;
  }

  getTypes() {
    return this.tab.types;
  }

  getStatuses() {
    return this.tab.statuses;
  }

  changeTypes(type) {
    this.updateUrl({types: type});
  }

  changeStatus(status) {
    this.updateUrl({status: status});
  }

  search(term) {
    if (term) {
      this.filteredThings = this.things.filter(thing => {
        return thing.name.toLowerCase().indexOf(term.toLowerCase()) != -1;
      });
    } else {
      this.refreshThings();
    }
  }

  openNewThing($event) {
    $event.preventDefault();
    $event.stopPropagation();

    this.thingModal.fire('thingsAdd.open', {areaId: this.defaultAreaId});
  }

  editLand($event) {
    $event.preventDefault();
    $event.stopPropagation();
    //this.landEvent.fire(this.land);
    console.log("editing land!");
    let area = new Area();
    area.areaId = this.defaultAreaId;
    this.openLandModalEvent.fire('edit', area);
    // popup Edit Modal
  }

  updateUrl(params){
    let navExtra :NavigationExtras = {
      queryParamsHandling: "merge",
      queryParams: params
    };

    this.router.navigate(['areas', this.defaultAreaId, 'things'], navExtra);
  }

//added
  // nextResults($event){
  //   $event.preventDefault();
  //   $event.stopPropagation();
  //   this.updateUrl({ types: '', status: '', continuationToken: ''});
  //   this.refreshThings();
  // }

  // getContinuationToken(){
  //   if(this.thingsResult)
  //   {
  //   return this.thingsResult["nextContinuationToken"];
  //   }
  // }
  //added
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/components/things/list/list.component.ts